import {
  CARRIER_VALIDATE_ACTION_TYPES,
  SEARCH_SAFER_ACTION_TYPES,
  COMPLIANCE_CHECK_ACTION_TYPES,
  CLEAR_COMPLIANCE,
} from '../actions/options'

const defaultState = {
  validCarrier: false,
  carrierData: { id: null },
  carrierUpdates: {},
  lookup: { id: null },
  loading: false,
  loadingSafer: false,
  error: null,
  compliance: {},
}

const {
  CARRIER_INVALID,
  CARRIER_REQUESTED,
  CARRIER_SUCCESS,
  CLEAR_SELECTED_CARRIER,
  SELECT_NEW_CARRIER,
  UPDATE_LOOKUP,
} = CARRIER_VALIDATE_ACTION_TYPES

const { REQUEST_SAFER, SAFER_FAILURE, SAFER_SUCCESS } = SEARCH_SAFER_ACTION_TYPES

const {
  COMPLIANCE_CHECK_FAILURE,
  COMPLIANCE_CHECK_REQUESTED,
  COMPLIANCE_CHECK_SUCCESS,
} = COMPLIANCE_CHECK_ACTION_TYPES

const optionsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case UPDATE_LOOKUP:
      return {
        ...state,
        carrierData: action.payload,
        lookup: action.payload,
      }
    case REQUEST_SAFER:
      return {
        ...state,
        loadingSafer: true,
        carrierSaferLookup: [],
        error: null,
      }
    case SAFER_SUCCESS:
      return {
        ...state,
        loadingSafer: false,
        carrierSaferLookup: action.payload,
        error: null,
      }
    case SELECT_NEW_CARRIER:
      return {
        ...state,
        carrierData: { id: null },
        carrierUpdates: { ...action.payload },
        loadingSafer: false,
      }
    case SAFER_FAILURE:
      return {
        ...state,
        loadingSafer: false,
        carrierSaferLookup: [],
      }
    case CARRIER_REQUESTED:
      return {
        ...state,
        loading: true,
        carrierData: { id: null },
        carrierUpdates: { mcNumber: action.payload.updateMc, dotNumber: action.payload.updateDot },
        validCarrier: false,
        error: null,
      }
    case CARRIER_SUCCESS:
      return {
        ...state,
        loading: false,
        carrierData: action.payload.carrierApplication,
        validCarrier: true,
        error: null,
      }
    case CARRIER_INVALID:
      return {
        ...state,
        loading: false,
        carrierData: { id: null },
        validCarrier: false,
      }
    case CLEAR_SELECTED_CARRIER:
      return {
        ...state,
        carrierData: { id: null },
      }
    case COMPLIANCE_CHECK_REQUESTED:
      return {
        ...state,
        compliance: {
          loading: true,
        },
      }
    case COMPLIANCE_CHECK_SUCCESS:
      return {
        ...state,
        compliance: {
          errors: action.payload.meetsRequirements
            ? []
            : action.payload.requirementsMatchResults
                .filter(({ valid }) => !valid)
                .map(({ shipperRequirement }) => shipperRequirement),
        },
      }
    case COMPLIANCE_CHECK_FAILURE:
      return {
        ...state,
        compliance: {
          errors: [],
          failed: true,
        },
      }
    case CLEAR_COMPLIANCE:
      return {
        ...state,
        ...defaultState,
      }
    default:
      return state
  }
}

export default optionsReducer
